import { HStack, Icon, VStack } from "@/shared/ui/primitives";

export interface ControlNodeProps {
	name: string;
	description: string;
	selected?: boolean;
	onEdit?: () => void;
	onDelete?: () => void;
}

export const ControlNode = (p: ControlNodeProps) => {
	return (
		<VStack
			className={`w-[280px] px-[24px] py-[20px] gap-[6px] rounded-[10px] bg-bg-regular relative items-start ${p.selected ? "outline-ct-weak" : "outline-outline"}`}
		>
			<span className="text-ct-regular text-sm font-medium">{p.name}</span>
			<span className="text-ct-strong text-lg font-medium">{p.description}</span>
			{p.selected && (
				<HStack className="absolute top-[-20px] right-[50%] translate-x-[50%] gap-[10px] px-[8px] py-[6px] rounded-[10px] bg-bg-weak outline-ct-weak text-ct-weak">
					<button type="button" onPointerDown={(e) => e.stopPropagation()} onClick={p.onEdit}>
						<Icon name="Setting" width={20} height={20} />
					</button>
					<button type="button" onPointerDown={(e) => e.stopPropagation()} onClick={p.onDelete}>
						<Icon name="Trash" width={20} height={20} />
					</button>
				</HStack>
			)}
		</VStack>
	);
};
